import ReactOnRails from "react-on-rails";
import ReactShare from "shared/components/react-share/ReactShare";
import ProgressBar from "shared/components/progress-bar/ProgressBar";
import LiveCountdown from "shared/components/live-countdown/LiveCountdown";
import GivingButton from "shared/components/giving-form-v2/App/CampaignShowGivingButtonV2";
import GlobalModalWrapper from "shared/components/global-modal/GlobalModalWrapper";
import FormattedCurrencyNumber from "shared/components/react-intl/FormattedCurrencyNumber";
import CampaignPage from "../src/microsite/campaigns/CampaignsPageWrapper";

ReactOnRails.register({ ReactShare });
ReactOnRails.register({ ProgressBar });
ReactOnRails.register({ LiveCountdown });
ReactOnRails.register({ GivingButton });
ReactOnRails.register({ GlobalModalWrapper });
ReactOnRails.register({ FormattedCurrencyNumber });
ReactOnRails.register({ CampaignPage });
